import { config } from '@app/config';
import { PREFIX } from '@app/constants';
import { IframePage } from '@app/pages/IframePage';

import type { FC } from 'react';

import '@pages/DocumentTemplates/styles/DocumentTemplates.desktop.scss';

// Филиал не передаётся: страница всегда показывает шаблоны активного
// филиала, а IframePage подставляет activeBranchId сам.
export const DocumentTemplates: FC = () => (
  <div className={`${PREFIX}document-templates`}>
    <IframePage host={config.documentFlowHost} isEmbedded />
  </div>
);
